import type {ReactElement} from 'react';
import React, { useState} from 'react';
import {Panel, PanelFooter, PanelFooterPrimaryDefaultAction, PanelHeader} from '@Components/panel';
import useDefaultPanelClose from '@Panels/hooks/useDefaultPanelClose';
import {ContextualMenu} from '@Components/contextual-menu';
import {Size, Type} from '@Components/button';
import {InputField} from '@Components/input-field-v2';
import {showEditorNotificationMessageGrowl} from '@Components/poster-editor/library/poster-editor-library';
import {useAppSelector} from '@/hooks';

export interface PosterEditorGridPanelProps {
  panelId: string;
}

function PosterEditorTitlePanel({...props}: PosterEditorGridPanelProps): ReactElement {
  const onClose = useDefaultPanelClose(props.panelId);
  const currentDesignName = useAppSelector((state) => {
    return state.posterEditor.posterObject?.name;
  });
  const [designName, setDesignName] = useState(currentDesignName);

  const getHeader = (): ReactElement => {
    return <PanelHeader onClose={onClose} title={window.i18next.t('pmwjs_title')} />;
  };

  const onApply = (): void => {
    void window.posterEditor?.whiteboard?.updateFromObject({
      name: designName,
    });
    showEditorNotificationMessageGrowl(window.i18next.t('pmwjs_title_updated'));
    onClose();
  };

  const getContent = (): ReactElement => {
    return (
      <ContextualMenu contentClassName="spacing-m-b-0 spacing-p-t-1 spacing-p-l-4 spacing-p-r-4 spacing-p-b-4" id="editor-mobile-title-option">
        <InputField
          input={designName}
          onInputChange={(val: string): void => {
            setDesignName(val);
          }}
        />
      </ContextualMenu>
    );
  };

  const getFooter = (): ReactElement => {
    return (
      <PanelFooter
        border={false}
        fullWidthPrimaryActions
        primaryActions={[
          <PanelFooterPrimaryDefaultAction
            key="title-footer-action"
            isFullWidth
            onClick={onApply}
            disabled={designName === currentDesignName || designName === ''}
            size={Size.SMALL}
            type={Type.PRIMARY}
            text={window.i18next.t('pmwjs_apply')}
          />,
        ]}
      />
    );
  };

  return <Panel panelHeader={getHeader()} panelContent={getContent()} panelFooter={getFooter()} />;
}

export default PosterEditorTitlePanel;
